// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2S_jX","col":"styles_col__2xOFF"};